import customerApi from '@/api/lottery/customer'

import {
  UPDATE_LOTTERY_CUSTOMER_DETAIL,
  CLEAR_LOTTERY_CUSTOMER_DETAIL
} from './mutation-types'

export default {
  state: {
    lotteryCustomerDetail: {}
  },
  mutations: {
    [UPDATE_LOTTERY_CUSTOMER_DETAIL] (state, payload) {
      state.lotteryCustomerDetail = Object.assign({}, state.lotteryCustomerDetail, payload)
    },
    [CLEAR_LOTTERY_CUSTOMER_DETAIL] (state) {
      state.lotteryCustomerDetail = {}
    }
  },
  actions: {
    getLotteryCustomerDetailByUserId ({ commit }, userId = 0) {
      console.debug(userId)
      return customerApi.getCustomerDetailByUserId(userId)
        .then(customerDetail => {
          console.debug(customerDetail)
          commit(UPDATE_LOTTERY_CUSTOMER_DETAIL, customerDetail)
        })
    },
    getLotteryCustomerDetailById ({ commit }, customerId = 0) {
      return customerApi.getCustomerDetailById(customerId)
        .then(customerDetail => {
          console.debug(customerDetail)
          commit(UPDATE_LOTTERY_CUSTOMER_DETAIL, customerDetail)
        })
    },
    updateLotteryCustomer ({ commit }, customerDetail) {
      commit(UPDATE_LOTTERY_CUSTOMER_DETAIL, customerDetail)
    },
    clearLotteryCustomerDetail ({ commit }) {
      commit(CLEAR_LOTTERY_CUSTOMER_DETAIL)
    }
  },
  getters: {
    lotteryCustomer (state) {
      return state.lotteryCustomerDetail.customer
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/module/lottery.js